export default __webpack_public_path__ + "static/media/calypso-mang-dairy-free-breakfast-bowls.74afd209.png";